module.exports = __webpack_public_path__ + "img/bonus_symbol_1.501e6d52.png";